// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2ilaw","inputWrap":"CustomTip_inputWrap__3djt1"};